import { ServiceGroupI } from '@/modules/myServices/types/api/Service'

export default class ServiceGroupItem {
  hidden: number
  id: number
  name: string
  order: number
  slug: string
  constructor(data: ServiceGroupI) {
    this.hidden = data.hidden
    this.id = data.id
    this.name = data.name
    this.order = data.order
    this.slug = data.slug
  }
}
